import React, { useEffect, useState } from 'react'
import { Button, Chip } from '@mui/material'
import LinkRoundedIcon from '@mui/icons-material/LinkRounded'
import hipersendService from '../../services/hipersend'
import { usePreserveQueryParamsNavigate } from '../../hooks/usePreserveQueryParamsNavigate'
import Text from '../Text'
import { PROVIDER_OFICIAL, mostrarCartao, seloDoCartao } from './regras'

// Entrada de "Conectar ao GLA Conecta" dentro de Configurações. Só existe para a
// API oficial e só quando o master não responde "indisponível". O recurso vem
// ligado por padrão no master; se a GLA puxar o freio (CONECTA_PAREAMENTO_LIGADO
// = "0"), o estado vira "indisponível" e o cartão some. Falha na consulta também
// esconde: melhor não oferecer o que pode não funcionar.
export default function CartaoNasConfiguracoes({ api, secret, provider, servico = hipersendService.conecta }) {
  const navegar = usePreserveQueryParamsNavigate()
  const [resposta, setResposta] = useState(null)

  useEffect(() => {
    let vivo = true
    setResposta(null)
    if (!api || !secret || provider !== PROVIDER_OFICIAL) return undefined
    servico.estado(api, secret)
      .then(r => { if (vivo) setResposta(r) })
      .catch(() => { if (vivo) setResposta(null) })
    return () => { vivo = false }
  }, [api, secret, provider, servico])

  if (!mostrarCartao(provider, resposta)) return null
  const selo = seloDoCartao(resposta)
  const conectado = resposta.situacao === 'conectado'

  return (
    <div className="py-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-start gap-3 min-w-0 flex-1 basis-[320px]">
          <LinkRoundedIcon aria-hidden="true" className="mt-[2px]" />
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <Text className="font-bold">Conectar ao GLA Conecta</Text>
              {selo && <Chip size="small" color="success" variant="outlined" label={selo.texto} />}
            </div>
            <Text className="max-w-[440px] font-light text-sm">
              {conectado
                ? 'Este número já recebe as respostas dos clientes no GLA Conecta. Veja a empresa e quem conectou.'
                : 'Use este mesmo número oficial para atender seus clientes no GLA Conecta, sem precisar de técnico.'}
            </Text>
          </div>
        </div>
        <Button variant="outlined" color="inherit" onClick={() => navegar('/settings/gla-conecta')}>
          {conectado ? 'Ver conexão' : 'Conectar'}
        </Button>
      </div>
    </div>
  )
}
